/**
 * Elastic Image
 *
 * @author Matej Svajger <hello@matejsvajger.com>
 */

import Image from './elements/image'
import Controls from './elements/controls'
// import Canvas from './elements/canvas'

export default class ElasticImage {
  constructor (el) {
    if (el) {
      this.image = new Image(el)
      this.init()
    }
  }

  async init () {
    await this.image.ready()

    // let canvas = new Canvas(
    //   this.image.img,
    //   this.image.width,
    //   this.image.height
    // )

    let controls = new Controls(
      document.querySelectorAll('img[data-role="image-source"]')
    )

    controls.addEventListener('click', ({ src }) => this.changeImage(src))
    window.addEventListener('resize', () => this.resize())

    // this.canvas = canvas
    this.controls = controls
  }

  async changeImage (src) {
    if (this.image.src !== src) {
      // await this.canvas.render()
      this.image.src = src
      // this.canvas.render()
    }
  }

  resize () {
    // let { width, height } = this.image.size
    // this.canvas.width = width
    // this.canvas.height = height
    // this.canvas.update()
  }

  set src (value) {
    this.changeImage(value)
  }
}
